import PropType from "prop-types"
import * as R from "ramda"
import React from "react"
import { withRouter } from "react-router"
import styled from "styled-components"
import Login from "../../containers/Login"
import Signup from "../../containers/Signup"
import { isLogin, endRegisterRace } from "../../utils/index"

const StyledButton = styled.button.attrs({
  className: "ui button teal"
})`
&& {
  width: 100%
  margin-bottom: 1em
}
`

class RegisterRace extends React.Component {
  state = {
    showLogin: false,
    showSignup: false
  }
  render() {
    const { slug, racesDetail, special, close_registration } = this.props
    return (
      <React.Fragment>
        <div className="ui segment">
          <h1 style={{ textAlign: "center" }}>
            {special ? (
              <span>
                <s>{R.path(["price"], racesDetail[0])}</s>
                <span style={{ color: "red", fontWeight: "bold" }}>
                  {` ${R.path(["special_price"], racesDetail[0])} ฿`}
                </span>
              </span>
            ) : (
              <span>{`${R.path(["price"], racesDetail[0])} ฿`}</span>
            )}{" "}
          </h1>
          {!endRegisterRace(this.props.race) ? (
            <StyledButton
              className="mobile-not-show"
              onClick={() => {
                this.props.isRegistered
                  ? this.props.history.push(`/me`)
                  : isLogin() && special
                  ? this.props.history.push(
                      `/races/${slug}/register/?special=true`
                    )
                  : isLogin() && !special
                  ? this.props.history.push(`/races/${slug}/register`)
                  : this.setState({ showLogin: true })
              }}
            >
              สมัคร
            </StyledButton>
          ) : (
            <button
              className="ui button red mobile-not-show"
              style={{ width: "100%", marginBottom: "1em" }}
            >
              ปิดรับสมัคร
            </button>
          )}
          <h3>รางวัลที่จะได้รับ</h3>
          <p>
            <i className="chess icon" />
            เหรียญรางวัล
          </p>
          <span>*จะได้รับเมื่อวิ่งครบตามกำหนดเท่านั้น</span>
        </div>
        <Login
          open={this.state.showLogin}
          onClose={() => this.setState({ showLogin: false })}
          toggleSignup={() => {
            this.setState({ showLogin: false })
            this.setState({ showSignup: true })
          }}
        />
        <Signup
          open={this.state.showSignup}
          onClose={() => this.setState({ showSignup: false })}
        />
      </React.Fragment>
    )
  }
}

RegisterRace.propType = {
  slug: PropType.string.isRequired,
  price: PropType.string.isRequired,
  racesDetail: PropType.arrayOf(PropType.object),
  showConfirmPayment: PropType.bool
}

export default withRouter(RegisterRace)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/RegisterRace/index.js